// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { useEffect, useRef, type ReactNode } from 'react';

import styles from './Strip.module.css';

export interface StripProps {
  /** What the cards are ("Typer", "Prøver", "Rum", "Sider"). */
  label: string;
  /** The active card's key: when it changes, that card scrolls into view. */
  activeKey?: string | number | null;
  children: ReactNode;
}

/**
 * The bottom tile's row of cards (`StripCard`). Scrolls sideways; keeps the
 * active card (`aria-pressed="true"`) in view as the selection moves (J/K).
 */
export function Strip({ label, activeKey, children }: StripProps) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const card = ref.current?.querySelector<HTMLElement>('[aria-pressed="true"]');
    card?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, [activeKey]);
  return (
    <div ref={ref} className={styles.strip} role="group" aria-label={label}>
      {children}
    </div>
  );
}
